module.exports = __webpack_public_path__ + "img/part3text.fe160f28.png";